export const GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS'
export const SET_DOCUMENTS_LOADING = 'SET_DOCUMENTS_LOADING'